(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initSignup(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const cookieName = root.dataset.cookie;
    const hasCookie = () => document.cookie.split(';').some(value => value.trim().startsWith(cookieName + '='));
    const remember = days => {
      document.cookie = cookieName + '=1; Max-Age=' + days * 86400 + '; Path=/; SameSite=Lax; Secure';
    };
    const success = !!root.querySelector('[data-alb-success]');
    let shown = false;
    let trigger;
    let timer;
    const show = () => {
      if (!root.isConnected || dialog.open) return;
      if (!success && (hasCookie() || document.hidden || document.querySelector('dialog[open]'))) return;
      trigger = document.activeElement;
      dialog.showModal();
      shown = true;
    };
    const close = () => dialog.close();
    dialog.addEventListener('close', () => {
      if (shown) remember(success ? 30 : 7);
      if (trigger && typeof trigger.focus === 'function') trigger.focus();
    });
    dialog.querySelector('[data-alb-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    const failed = !!root.querySelector('[role="alert"]');
    if (success) remember(30);
    if (success || failed) {
      show();
    } else if (!hasCookie() && !window.Shopify?.designMode) {
      timer = setTimeout(show, Number(root.dataset.delay) || 7000);
      window.addEventListener('pagehide', () => clearTimeout(timer), { once: true });
    }
    document.addEventListener('shopify:section:select', event => {
      if (window.Shopify?.designMode && root.closest('.shopify-section')?.id === 'shopify-section-' + event.detail.sectionId) show();
    });
  }
  document.querySelectorAll('[data-alb-signup]').forEach(initSignup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-alb-signup]').forEach(initSignup));
})();

  } catch(e) { console.error(e); }
})();
})();
